// Der EINE Ducking-Vertrag der App: zwei CustomEvents auf `document`.
//
// 'tts:start' / 'tts:end' gibt es seit dem Legacy-Chat (public/js/chat.js) und
// das Hintergrundradio (public/js/radio-player.js) hoert bis heute darauf. Der
// Vertrag bleibt unveraendert; NEU ist nur ein optionales `detail.source`,
// damit ein Hoerer unterscheiden kann, WER gerade Vorrang hat:
//
//   'tts'  — Vorlesen einer Nachricht. Andere Quellen ducken (leiser), damit
//            die Stimme oben liegt; danach geht es lauter weiter.
//   'live' — Live-Gespraech/Anruf. Die Sitzung bringt ihre EIGENE Szenenmusik
//            mit, also darf keine zweite Musikquelle daneben laufen: die
//            Klangbuehne PAUSIERT (nicht duckt) und nimmt danach wieder auf.
//
// Alt-Hoerer ohne detail-Auswertung (radio-player.js) sehen exakt das bisherige
// Verhalten. Fehlt `detail`, gilt 'tts'.

export const DUCKING_START_EVENT = 'tts:start';
export const DUCKING_END_EVENT = 'tts:end';

export type DuckingSource = 'tts' | 'live';

export interface DuckingEventDetail {
  source: DuckingSource;
}

export function dispatchDuckingEvent(
  name: typeof DUCKING_START_EVENT | typeof DUCKING_END_EVENT,
  source: DuckingSource = 'tts',
): void {
  if (typeof document === 'undefined') return;
  try {
    document.dispatchEvent(new CustomEvent<DuckingEventDetail>(name, { detail: { source } }));
  } catch {
    // Ducking ist Komfort — ein fehlender CustomEvent-Konstruktor darf nie werfen.
  }
}

export function duckingSourceOf(event: Event): DuckingSource {
  const detail = (event as CustomEvent<Partial<DuckingEventDetail>>).detail;
  return detail?.source === 'live' ? 'live' : 'tts';
}
